import { useEffect } from "react"
import type { UserMetadata } from "types/auth"

/**
 * Stamp lastOpenedAt once per page load and account. Keyed on the account
 * (sub), not the Auth0 user object: that object is replaced during a load —
 * the boot snapshot's user handing over to the real one, the token renewal
 * after boot — and each write is an Auth0 Management API call server-side.
 */
export const useRecordLastOpened = (sub: string | undefined, update: (data: Partial<UserMetadata>) => void) => {
  useEffect(() => {
    if (sub) update({ lastOpenedAt: new Date().toISOString() })
    // once per account: `update` is a fresh function every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sub])
}
